<div class="breadcrumb">
  <p-breadcrumb [model]="menu$ | async"></p-breadcrumb>
</div>
